import { useRef } from "react";
import "./App.css";
import AccessSection from "./components/AccessSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import Header from "./components/Header";
import IssueSection from "./components/IssueSection";
import MenuComponent from "./components/MenuComponent";
// import ProcedureSection from "./components/ProcedureSection";
import ReasonSection from "./components/ReasonSection";
import { SHOP_INFO } from "./config";

function App() {
  const reasonSectionRef = useRef<HTMLDivElement>(null);

  const handleTopClick = () => {
    reasonSectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App">
      <Header />
      <div className="top-section">
        <button
          type="button"
          onClick={handleTopClick}
          aria-label="理由セクションへ移動"
          className="block w-full p-0 border-0 bg-transparent"
          style={{ cursor: "pointer", display: "block" }}
        >
          <picture className="block w-full">
            <source
              srcSet={`${SHOP_INFO.basePath}/top_smartphone.webp`}
              media="(max-width: 768px)"
              type="image/webp"
            />
            <img
              src={`${SHOP_INFO.basePath}/top.webp`}
              alt="top"
              className="top-image"
              width="1920"
              height="1060"
            />
          </picture>
        </button>
      </div>
      <div ref={reasonSectionRef}>
        <ReasonSection />
      </div>
      <IssueSection />
      <MenuComponent />
      {/* <ProcedureSection /> */}
      <FAQSection />
      <AccessSection />
      <Footer />
    </div>
  );
}

export default App;
